<script module lang="ts">
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';

	export interface ButtonV3Props extends SbBlokData {
		text: string;
		size: string;
		desktop_size?: string;
		theme: string;
		type: string;
		alignment: 'center' | 'left' | 'right' | 'stretch';
		link: SbLink;
		title?: string;
	}

	let isMobile = $derived(!innerWidth.current || innerWidth.current < 1024);
</script>

<script lang="ts">
	import Button from '$lib/buttons/v3/button.svelte';
	import type { SbLink } from '../types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import { editable } from '../editable';
	import { innerWidth } from 'svelte/reactivity/window';

	interface Props {
		content: ISbStoryData<ButtonV3Props>['content'];
		onclick?: () => void;
	}

	let { content, onclick }: Props = $props();

	let buttonAction = $derived(
		onclick
			? { onclick }
			: {
					href: getSbUrl(content.link),
					target: content.link?.target === '_self' ? undefined : content.link?.target
				}
	);
</script>

<div
	use:editable={content}
	class={[
		'flex',
		{
			'justify-center': content.alignment === 'center',
			'justify-end': content.alignment === 'right'
		}
	]}
>
	<Button
		{...buttonAction}
		title={content.title}
		class={[
			isMobile ? content.size : content.desktop_size || content.size,
			content.theme,
			content.type,
			content.alignment === 'stretch' ? 'flex-1' : 'default'
		]
			.filter((c) => c !== 'default')
			.join(' ')}
	>
		{content.text}
	</Button>
</div>
